import Dishes from './Dishes';

export default Dishes;
